// Phase 1A Step 34 — Single chain row in the multi-market dashboard mock.
// Extracted from MultiMarketDashboard.tsx for LOC ceiling.

import type { ChainMock } from "./landing-data.ts";

interface MultiMarketChainRowProps {
  c: ChainMock;
  showBorder: boolean;
}

export function MultiMarketChainRow({ c, showBorder }: MultiMarketChainRowProps): JSX.Element {
  return (
    <div
      style={{
        display: "grid",
        gridTemplateColumns: "100px 110px 1fr 200px 180px 120px",
        padding: "24px 32px",
        alignItems: "center",
        gap: 24,
        borderBottom: showBorder ? "1px solid var(--border)" : 0,
        opacity: c.live ? 1 : 0.65,
      }}
    >
      <div
        style={{
          fontSize: 28,
          width: 56,
          height: 56,
          borderRadius: 4,
          background: c.live ? "rgba(212, 168, 67, 0.08)" : "rgba(255,255,255,0.03)",
          border: c.live ? "1px solid var(--accent-deep)" : "1px solid var(--border)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {c.icon}
      </div>

      <div>
        <div
          className="display"
          style={{
            fontSize: 18,
            color: c.live ? "var(--accent)" : "var(--text)",
            letterSpacing: "0.04em",
          }}
        >
          {c.code}
        </div>
        <div
          className="mono"
          style={{
            fontSize: 9,
            color: "var(--text-dim)",
            letterSpacing: "0.18em",
            textTransform: "uppercase",
            marginTop: 3,
          }}
        >
          {c.market}
        </div>
      </div>

      <div>
        <div
          className="mono"
          style={{
            fontSize: 11,
            letterSpacing: "0.12em",
            color: "var(--text-muted)",
            textTransform: "uppercase",
            marginBottom: 8,
          }}
        >
          {c.week}
        </div>
        <div
          style={{
            width: "100%",
            height: 4,
            background: "var(--border)",
            overflow: "hidden",
          }}
        >
          <div
            style={{
              width: `${c.bar * 100}%`,
              height: "100%",
              background: "var(--accent)",
              transition: "width .5s",
            }}
          />
        </div>
      </div>

      <div className="mono" style={{ fontSize: 18, color: "var(--text)", letterSpacing: "0.02em" }}>
        {c.value}
      </div>

      <div
        className="mono"
        style={{ fontSize: 12, color: "var(--success)", letterSpacing: "0.04em" }}
      >
        {c.delta}
      </div>

      <div style={{ textAlign: "right" }}>
        {c.live ? (
          <span
            className="mono"
            style={{
              fontSize: 9,
              letterSpacing: "0.18em",
              color: "var(--success)",
              textTransform: "uppercase",
              display: "inline-flex",
              alignItems: "center",
              gap: 6,
            }}
          >
            <span className="live-dot" style={{ width: 5, height: 5 }} />
            Active
          </span>
        ) : (
          <span
            className="mono"
            style={{
              fontSize: 9,
              letterSpacing: "0.18em",
              color: "var(--text-dim)",
              textTransform: "uppercase",
            }}
          >
            Preview
          </span>
        )}
      </div>
    </div>
  );
}
